import { Box, Button, Typography } from "@mui/material";
import { Command } from "~/components/guides/components/command";
import { useTheme } from "@mui/material";
import { GithubIcon } from "~/icons";

export interface SecurityPipelineGithubSetupStepTwoProps {
  appInstallationLink: string | null | undefined;
}

export const SecurityPipelineGithubSetupStepTwo = ({
  appInstallationLink,
}: SecurityPipelineGithubSetupStepTwoProps) => {
  const theme = useTheme();
  return (
    <Box pb={4}>
      <Command
        number={2}
        options={{
          fontSize: { xs: 16 },
          dotColor: theme.palette.background.lightest,
        }}
      >
        Install Security pipeline
      </Command>

      <Box sx={{ mt: 2, pl: 6 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, mt: 2 }}
        >
          Give it permission to access to access your newly created repo(s).
        </Typography>
        <Button
          disabled={!appInstallationLink}
          variant="contained"
          color="primary"
          href={appInstallationLink || "#"}
          endIcon={<GithubIcon />}
        >
          Install Security pipeline
        </Button>
      </Box>
      {/* <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography color="text.secondary" sx={{ mb: 2, mt: 2 }}>
                Generate SSH key
              </Typography>
              <Controller
                name="generateSSHKey"
                control={formMethods.control}
                disabled={!!integrationId}
                render={({ field }) => (
                  <Switch
                    {...field}
                    checked={field.value || false}
                    size="small"
                  />
                )}
              />
            </Box>
            {integrationId && publicKey && (
              <Code copyButton children={publicKey} />
            )} */}
    </Box>
  );
};
